import { Card, Button, Divider } from 'antd';
import { useEffect } from 'react';
import { useAppDispatch } from '../../methods/redux/hooks';
import {
	getFluidReport,
	getTodaysApy,
} from '../../methods/redux/reducers/general';
import FluidReport from '../../settings/general/FluidReport';
import ViewTodayApy from '../../settings/general/ViewTodayApy';

const LendingZone = () => {
	const dispatch = useAppDispatch();
	useEffect(() => {
		dispatch(getFluidReport());
		dispatch(getTodaysApy());
	}, [getFluidReport, getTodaysApy]);

	return (
		<div>
			<Card>
				<h2>Lending Zones</h2>

				<p>Manage blockchain Lending / yield Process</p>
				<div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
					<Button type="default">
						<a
							href=" https://autoyield.xend.africa/"
							target="_blank"
							rel="noopener noreferrer"
						>
							xAuto
						</a>
					</Button>
					<Button type="default">
						<a
							href="https://fluid.instadapp.io/lending/8453"
							target="_blank"
							rel="noopener noreferrer"
						>
							Fluid Lending
						</a>
					</Button>
				</div>
				<br />
			</Card>
			<Divider />

			<Card>
				<ViewTodayApy />
				<br />
			</Card>
			<Divider />

			<Card id="daily-apy">
				<br />
				<FluidReport />
			</Card>
		</div>
	);
};

export default LendingZone;
